<div class="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/95 backdrop-blur-xl text-gray-900 select-none overflow-hidden">
  
  <!-- Glowing Background Ambient Blurs -->
  <div class="absolute w-72 h-72 rounded-full bg-[var(--primary)]/15 blur-3xl animate-pulse pointer-events-none"></div>
  <div class="absolute w-96 h-96 rounded-full bg-[var(--secondary)]/10 blur-3xl animate-pulse delay-700 pointer-events-none"></div>

  <!-- Central Emblem with Dual Ring Spinner -->
  <div class="relative flex items-center justify-center w-28 h-28 mb-6">
    <!-- Outer Gradient Spinner Ring -->
    <div class="absolute inset-0 rounded-full border-4 border-transparent border-t-[var(--primary)] border-r-[var(--primary)]/40 animate-spin"></div>
    <!-- Inner Counter-Spinning Ring -->
    <div class="absolute inset-2 rounded-full border-4 border-transparent border-b-[var(--secondary)] border-l-[var(--secondary)]/40 animate-[spin_1.5s_linear_infinite_reverse]"></div>
    
    <!-- Logo with Pulse Effect -->
    <div class="relative w-16 h-16 rounded-2xl bg-white p-2 shadow-lg border border-gray-100 flex items-center justify-center">
      <img
        src="./icon.png"
        alt="Hela Geek"
        class="w-full h-full object-contain animate-pulse"
      />
    </div>
  </div>

  <!-- Brand Title -->
  <div class="flex flex-col items-center gap-2 text-center z-10">
    <h1 class="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight flex items-center gap-1.5">
      Hela <span class="text-[var(--primary)]">Geek</span>
    </h1>
    
    <!-- Animated Loading Progress Line -->
    <div class="w-36 h-1 bg-gray-200 rounded-full overflow-hidden mt-1 relative">
      <div class="absolute inset-y-0 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] rounded-full animate-progress"></div>
    </div>
    
    <!-- Subtitle -->
    <p class="text-xs font-semibold text-gray-400 uppercase tracking-widest mt-2 animate-pulse">
      Loading Experience
    </p>
  </div>
</div>
